var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgManage = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "manage",
    width: 18.308,
    height: 17,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.308 16.346a.654.654 0 0 1-.654.654h-17A.654.654 0 0 1 0 16.346V.654C0 .293.293 0 .654 0h17c.361 0 .654.293.654.654v15.692ZM17 5.931v-.7H1.308v10.461H17V5.931Zm0-4.623H1.308v2.615H17V1.308ZM2.942 3.269a.654.654 0 1 1 0-1.307.654.654 0 0 1 0 1.307Zm2.289 0a.654.654 0 1 1 0-1.307.654.654 0 0 1 0 1.307Zm2.288 0a.654.654 0 1 1 0-1.307.654.654 0 0 1 0 1.307Z",
    fill: "#264D6D",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgManage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/manage.5b4dcff2.svg";
export { ForwardRef as ReactComponent };